import React from "react";

export default function DogAvatar({ dog, size = 28, className = "" }) {
  const raw = dog?.photo_base64;
  const src = raw ? (raw.startsWith("data:") ? raw : `data:image/jpeg;base64,${raw}`) : null;
  const initial = (dog?.name || "?").charAt(0).toUpperCase();
  return (
    <div
      className={`rounded-full overflow-hidden bg-[#F6DED5] flex items-center justify-center shrink-0 ${className}`}
      style={{ height: size, width: size }}
    >
      {src ? (
        <img src={src} alt={dog?.name || ""} className="h-full w-full object-cover" />
      ) : (
        <span className="font-extrabold text-[#B54828]" style={{ fontSize: size * 0.42 }}>{initial}</span>
      )}
    </div>
  );
}
